import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgHelpIcon = function SvgHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 5.75c-9.792 0-17.75 6.583-17.75 14.67 0 4.464 2.43 8.636 6.675 11.441l.614.404v6.647l6.335-4.218.541.092c1.185.201 2.384.302 3.585.303 9.755 0 17.75-6.583 17.75-14.67S33.255 5.75 23.5 5.75m-1.485 13.826c2.704-.458 4.217-1.485 4.217-2.888 0-1.22-.963-2.017-2.384-2.017a4.74 4.74 0 0 0-3.502 1.44L18.1 13.726a8.3 8.3 0 0 1 5.73-2.274c3.484 0 6.07 2.246 6.07 5.272 0 2.31-1.33 3.85-4.447 5.06v2.522h-3.438zm0 10.287v-3.43h3.438v3.439zm-11.68 14.192V33.732C5.65 30.412 3 25.6 3 20.419 3 10.811 12.168 3 23.5 3S44 10.811 44 20.42c0 9.608-9.168 17.419-20.5 17.419a24 24 0 0 1-3.502-.257z"
  })));
};

export { SvgHelpIcon as default };
